import React, { Component } from 'react'
import ProTypes from 'prop-types'
import publicIp from "public-ip"

import { connect } from 'react-redux'
import { req_list_ccw_search_page, req_list_ccw_search_page_viewer, req_add_ccw_haviorLog, req_delete_ccw_haviorLog, req_add_ccw_haviorLog_none } from '../../api'
import { Image, Tag, Modal, message, Alert, Pagination } from 'antd'

import VideoPlayer from 'react-video-js-player'
import { formateShortDate } from '../../utils/dateUtil'
import { API_BASE } from '../../utils/contrains'

import DiscussModal from './discuss-modal'

class Main extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        searchName: null,
        initView: true,
        loading: false,
        item: {},
        items: null,
        errMsg: null,
        ip: '',
        current: 1,
        pageSize: 12,
        total: 0,
        isDiscussModal: false
    }

    static propTypes = {
        searchName: ProTypes.string.isRequired
    }

    componentDidMount = () => {
        (async () => {
            const ip = await publicIp.v4()
            this.setState({ ip })
        })();
    }

    //當組件接收到新的ProTypes屬性值
    componentWillReceiveProps(newProps) {
        //指定了新的searchName需要請求
        const { searchName } = newProps
        this.to_do_search(searchName)
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_replyContent = async (searchName, sourceIp) => {
        const { current, pageSize } = this.state
        const { token, userCode } = this.props.user
        this.setState({ loading: true })
        const result = token ? await req_list_ccw_search_page_viewer(current, pageSize, searchName, sourceIp, userCode) : await req_list_ccw_search_page(current, pageSize, searchName, sourceIp)
        if (result.total > 0) {
            const total = result.total
            //const rows = content.map((item, index) => { return { nid: item.ObjectCollectionNid, name: item.ObjectCollectionName, description: item.ObjectCollectionDescription} })
            const rows = result.data
            //console.log(rows)
            this.setState({ loading: false, items: rows, total, searchName })
        } else {
            const content = null
            this.setState({ loading: false, items: content })
        }
    }

    api_add_havior = async (item) => {
        const { token } = this.props.user
        await req_add_ccw_haviorLog(item, token)
    }

    api_add_havior_na = async (item) => {
        await req_add_ccw_haviorLog_none(item)
    }

    api_del_havior = async (item) => {
        const { token } = this.props.user
        const { code, type, nid } = item
        await req_delete_ccw_haviorLog(code, type, nid, token)
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    to_do_search = (searchName) => {
        const newReg = /[`~!@#$%^&*()+=|{}':;',/.<>/?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？]|[\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/;

        if (newReg.test(searchName)) {
            message.info("輸入框內有特殊表情或特殊字元，請刪除重新輸入")
        } else {
            //console.log(searchName)
            if (searchName.length > 0) {
                // 更新狀態(請求中)
                this.setState({
                    current: 1,
                    initView: false,
                    loading: true,
                    items: null
                })
                this.api_list_replyContent(searchName, this.state.ip)
            }
        }
    }

    keySingleRender(text, key) {
        if (key && text && typeof text === 'string' && typeof key === 'string') {
            const newTextArr = text.split("").map(t => {
                return key.toLowerCase().indexOf(t.toLowerCase()) > -1 ? `<Fragment class="redTip">${t}</Fragment>` : t;
            });
            const newText = newTextArr.join("");
            return (<span dangerouslySetInnerHTML={{ __html: newText }} />);
        } else {
            return text;
        }
    }

    style_switch_text_tag(name, value) {
        let ans = '其他'

        switch (name) {
            case 'LICENSE':
                switch (value) {
                    case 'BOTH':
                        ans = '無限制'
                        break;
                    case 'BYNCSA':
                        ans = '非商業性分享'
                        break;
                    case 'COPYRIGHT':
                        ans = '版權所有'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'TYPE':
                switch (value) {
                    case 'OTHER':
                        ans = '其它'
                        break;
                    case '2D':
                        ans = '平面'
                        break;
                    case '3D':
                        ans = '立體'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'ORIGINAL':
                switch (value) {
                    case 'BOTH':
                        ans = '其它'
                        break;
                    case 'NO':
                        ans = '非原創'
                        break;
                    case 'YES':
                        ans = '原創'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'PUBLIC':
                switch (value) {
                    case 'NO':
                        ans = '關閉瀏覽'
                        break;
                    case 'YES':
                        ans = '開放瀏覽'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            default:
                // OTHER
                break;
        }
    }

    style_switch_color_tag(name, value) {
        let ans = '#87d068'
        switch (name) {
            case 'LICENSE':
                switch (value) {
                    case 'BOTH':
                        ans = 'olive'
                        break;
                    case 'BYNCSA':
                        ans = 'sienna'
                        break;
                    case 'COPYRIGHT':
                        ans = 'goldenRod'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'TYPE':
                switch (value) {
                    case 'OTHER':
                        ans = 'magenta'
                        break;
                    case '2D':
                        ans = 'darkSlateBlue'
                        break;
                    case '3D':
                        ans = 'indigo'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'ORIGINAL':
                switch (value) {
                    case 'BOTH':
                        ans = 'plum'
                        break;
                    case 'NO':
                        ans = 'steelBlue'
                        break;
                    case 'YES':
                        ans = 'darkOrange'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'PUBLIC':
                switch (value) {
                    case 'NO':
                        ans = 'dimGray'
                        break;
                    case 'YES':
                        ans = 'green'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            default:
                // OTHER
                break;
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    handleClick = (e, item, type) => {
        const { items } = this.state
        const { ObjectCollectionNid } = item
        const { token } = this.props.user
        if (token) {
            const { userCode, userName } = this.props.user
            const { MyLikeTotal, MyTagTotal } = item
            const data = {
                HaviorType: type,
                OperatorCode: userCode,
                OperatorName: userName,
                ObjectCollectionNid: ObjectCollectionNid,
                Description: ''
            }
            const foundIndex = items.findIndex(x => x.ObjectCollectionNid === item.ObjectCollectionNid)
            switch (type) {
                case 'SEEN':
                    this.api_add_havior(data)
                    break
                case 'LIKE':
                    if (MyLikeTotal > 0) {
                        const delLike = {
                            code: userCode,
                            type: type,
                            nid: ObjectCollectionNid
                        }
                        items[foundIndex].MyLikeTotal = 0
                        items[foundIndex].TotalLikeTotal = items[foundIndex].TotalLikeTotal - 1
                        this.setState({ items })

                        this.api_del_havior(delLike)
                        message.warn('註銷[喜歡]')
                    } else {
                        items[foundIndex].MyLikeTotal = 1
                        items[foundIndex].TotalLikeTotal = items[foundIndex].TotalLikeTotal + 1
                        this.setState({ items })

                        this.api_add_havior(data)
                        message.success('喜歡')
                    }
                    break
                case 'TAG':
                    if (MyTagTotal > 0) {
                        const delTag = {
                            code: userCode,
                            type: type,
                            nid: ObjectCollectionNid
                        }
                        items[foundIndex].MyTagTotal = 0
                        items[foundIndex].TotalTagTotal = items[foundIndex].TotalTagTotal - 1
                        this.setState({ items })

                        this.api_del_havior(delTag)
                        message.warn('取消[關注]')
                    } else {

                        items[foundIndex].MyTagTotal = 1
                        items[foundIndex].TotalTagTotal = items[foundIndex].TotalTagTotal + 1
                        this.setState({ items })

                        this.api_add_havior(data)
                        message.success('關注')
                    }
                    break
                case 'DISCUSS':
                    this.setState({ isDiscussModal: true, item })
                    break
                default:

            }

        } else {
            if (type === 'SEEN') {
                const seen = {
                    HaviorType: type,
                    OperatorCode: 'NA',
                    OperatorName: '匿名',
                    ObjectCollectionNid: ObjectCollectionNid,
                    Description: ''
                }
                this.api_add_havior_na(seen)
            } else if (type === 'DISCUSS') {

                this.setState({ isDiscussModal: true, item })

            }
        }
        //console.log(item, type)
    }

    onChange = page => {
        //console.log(page);
        const { searchName, ip } = this.state
        this.setState({
            current: page,
            initView: false,
            loading: true,
            items: null
        }, ()=>{
            this.api_list_replyContent(searchName, ip)
        })
    };

    //////////////////////////////////////////////////////////

    render() {
        const { initView, loading, items, errMsg } = this.state
        const imagenotfoundurl = 'https://www.salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png'
        //const { searchName } = this.props
        if (initView) {
            //初始畫面
            return <div className="container"></div>
        } else if (loading) {
            // 正在載入中
            return <div className="container">
                <div className="text-center">
                    <button className="btn btn-light text-dark" type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 查詢中 ......
                    </button>
                </div>
            </div>
        } else if (errMsg) {
            // 出現錯誤
            return <div className="container"><h2>{errMsg}</h2></div>
        } else {
            if (items) {
                const { isDiscussModal, item, total, current } = this.state
                const { token } = this.props.user
                return (
                    <>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <Alert message={'本次查詢結果：共' + total + '筆'} type="info" showIcon />
                                </div>
                            </div>
                            <p></p>
                            <div className="row">
                                <div className="col-md-12">
                                    <Pagination current={current} onChange={this.onChange} total={total} />
                                </div>
                            </div>
                            <p></p>
                            <div className="row">
                                {
                                    items.map((item, index) => {
                                        return (
                                            <div className="col-md-4" key={index}>
                                                <div className="card mb-4 shadow-sm">
                                                    {item.ObjectVideoFilePath === '' ?
                                                        (<Image
                                                            src={item.ObjectImageFilePath === '' ? imagenotfoundurl : API_BASE + item.ObjectImageFilePath}
                                                            onClick={(e) => this.handleClick(e, item, 'SEEN')}
                                                        />) : (<VideoPlayer
                                                            controls={true}
                                                            src={API_BASE + item.ObjectVideoFilePath}
                                                            poster={item.ObjectImageFilePath === '' ? imagenotfoundurl : API_BASE + item.ObjectImageFilePath}
                                                            width="348"
                                                            onClick={(e) => this.handleClick(e, item, 'SEEN')}
                                                        />)}

                                                    <div className="card-body">
                                                        <p className="card-text"> <Tag color="default"><i className="fas fa-file-alt"></i> {item.ObjectCollectionNid }</Tag>{item.ObjectCollectionName}</p>
                                                        <p className="card-text">{<span dangerouslySetInnerHTML={{ __html: item.ObjectCollectionDescription }} />}</p>
                                                        <p> <Tag color="default">{this.style_switch_text_tag('TYPE', item.ObjectType)}</Tag><span>/{' '}</span>
                                                            <Tag color="default">{this.style_switch_text_tag('ORIGINAL', item.IsOriginality)}</Tag><span>/{' '}</span>
                                                            <Tag color="default">{this.style_switch_text_tag('LICENSE', item.CreativeCommonsLicense)}</Tag></p>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="btn-group">
                                                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => this.handleClick(e, item, 'LIKE')} disabled={token ? false : true}><i className="fas fa-heart" style={{ color: item.MyLikeTotal > 0 ? 'red' : 'block' }}></i> {item.TotalLikeTotal}</button>
                                                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => this.handleClick(e, item, 'TAG')} disabled={token ? false : true}><i className="fas fa-tag" style={{ color: item.MyTagTotal > 0 ? 'orange' : 'block' }}></i> {item.TotalTagTotal}</button>
                                                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => this.handleClick(e, item, 'DISCUSS')} ><i className="fas fa-comment" style={{ color: item.MyDiscussTotal > 0 ? 'blue' : 'block' }}></i> {item.TotalDiscussTotal}</button>
                                                            </div>
                                                            <span>{item.ObjectOwnerName} 作品</span>
                                                            <small className="text-muted">{formateShortDate(item.RecordCreateDateTime)}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <Modal
                            destroyOnClose={true}
                            visible={isDiscussModal}
                            width={'65%'}
                            onOk={() => {
                                this.setState({ isDiscussModal: false })
                            }}
                            onCancel={() => {
                                this.setState({ isDiscussModal: false })
                            }}
                            cancelButtonProps={{ style: { display: 'none' } }}
                            okText={'關閉'}
                        >
                            <DiscussModal objectCollection={item} />
                        </Modal>
                    </>
                )
            } else {
                return <div className="container"><h2>查無相關作品</h2></div>
            }
        }
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(Main)